<template>
  <div class="py-3">

    <div class="border border-1 rounded-3 p-3 mb-3">
      <!-- 🔵 TÍTULO SUPERIOR -->
      <div class="row mb-3 border-bottom pb-2 mx-1">
        <div class="col-12 d-flex justify-content-between align-items-center">
          <h4 class="text-primary mb-0 fw-bold"><i class="bi bi-person-lines-fill me-2"></i>EDITAR POSTULANTE</h4>
          <p class="pb-0 mb-0 fs-5 fw-semibold text-secondary text-uppercase">
            {{ posDescripcion }}
          </p>
        </div>
      </div>

      <!-- 🔵 ALERTA -->
      <div class="position-relative py-1 px-5">
        <div v-if="alerta" class="alert alert-info" role="alert">
          Se realizó con éxito los siguientes cambios!!
        </div>
      </div>

      <!-- 🔵 SECCIÓN FOTO Y TALLAS -->
      <div class="row py-2 mx-1">
        <!-- COLUMNA IZQUIERDA: FOTO Y TALLAS (APILADAS VERTICALMENTE) -->
        <div class="col-12 col-md-3 border-end pe-md-4 mb-4 mb-md-0">
          <div class="text-center mb-4">
            <label for="imageUpload"
              class="image-upload-circle d-flex justify-content-center align-items-center mx-auto position-relative mb-2 shadow-sm">
              <div v-if="loadingImagen" class="spinner-border text-success" role="status"></div>
              <template v-else>
                <span v-if="!previewUrl" class="upload-text text-muted small">Subir foto</span>
                <img v-else :src="previewUrl" alt="Foto Postulante" class="img-preview" />
              </template>
              <div class="overlay-camera"><i class="bi bi-camera-fill"></i></div>
            </label>
            <input type="file" id="imageUpload" accept="image/*" style="display: none;"
              @change="handleImageUpload" />
            <p class="reducirTamaño text-secondary fw-bold text-center">FOTO TIPO CARNET <br>(FONDO BLANCO)</p>
          </div>

          <div class="mb-3 bg-light p-2 rounded shadow-sm">
            <label class="tamaño d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-person-fill text-warning"></i> TALLA POLO:</label>
            <select class="form-select tamaños" @change="form.posPolo = $event.target.value" >
              <option disabled selected> {{desPolo || "-- SELECCIONAR --"}} </option>
              <option v-for="polo in polos" :key="polo.id" :value="polo.parCorrelativo">{{ polo.parDescripcion }}</option>
            </select>
          </div>

          <div class="mb-3 bg-light p-2 rounded shadow-sm">
            <label class="tamaño d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-person-standing text-secondary"></i> TALLA PANTALÓN:</label>

            <select class="form-select tamaños" @change="form.posPantalon = $event.target.value" >
              <option disabled selected> {{desPantalon || "-- SELECCIONAR --"}} </option>
              <option v-for="panta in pantalon" :key="panta.id" :value="panta.parCorrelativo">{{ panta.parDescripcion }}</option>
            </select>
          </div>

          <div class="mb-3 bg-light p-2 rounded shadow-sm">
            <label class="tamaño d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-universal-access text-primary"></i> TALLA CALZADO:</label>
            <select class="form-select tamaños" @change="form.posCalzado = $event.target.value"  >
              <option disabled selected> {{desCalzado || "-- SELECCIONAR --"}} </option>
              <option v-for="zapato in zapatos" :key="zapato.id" :value="zapato.parCorrelativo">{{ zapato.parDescripcion }}</option>
            </select>
          </div>
        </div>

        <!-- COLUMNA DERECHA: RESTO DEL FORMULARIO -->
        <div class="col-12 col-md-9 ps-md-4">
          <div class="row gx-3 gy-2">
            
            <!-- FILA 1: TIPO DOCUMENTO | N° DOCUMENTO | GENERO | ESTADO CIVIL -->
            <div class="col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-card-text fs-6 text-primary"></i> TIPO DOCUMENTO:</label>
              <select class="form-select tamaños" @change="dosomething($event)">
                <option selected disabled>{{ desTipDocumento }}</option>
                <option v-for="arreglarItems in Arreglar" :key="arreglarItems.id" :value="arreglarItems.parCorrelativo">
                  {{ arreglarItems.parDescripcion }}
                </option>
              </select>
            </div>

            <div class="form-group col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2
              ">
                <i class="bi bi-credit-card fs-6 text-warning"></i> N° DOCUMENTO:</label>
              <div class="input-group">
                <input type="number" class="form-control tamaños" v-model="form.posNroDocumento" />
                <button class="btn btn-primary py-0 px-2" type="button" @click="consultarDni(form.posNroDocumento)">
                  <i class="bi bi-search fs-6"></i>
                </button>
              </div>
            </div>

             <!-- FILA 2: APELLIDO PATERNO | APELLIDO MATERNO | NOMBRES | FECH. NACIMIENTO -->
            <div class="form-group col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-person fs-6 text-success"></i> APELLIDO PATERNO:</label>
              <input type="text" class="form-control tamaños" v-model="form.posApePaterno" @input="form.posApePaterno = form.posApePaterno.replace(/^\s+/, '')" />
            </div>

            <div class="form-group col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-person fs-6 text-info"></i> APELLIDO MATERNO:</label>
              <input type="text" class="form-control tamaños" v-model="form.posApeMaterno" @input="form.posApeMaterno = form.posApeMaterno.replace(/^\s+/, '')" />
            </div>

            <div class="form-group col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-person-badge fs-6 text-primary"></i> NOMBRES:</label>
              <input type="text" class="form-control tamaños" v-model="form.posNombre" @input="form.posNombre = form.posNombre.replace(/^\s+/, '')" />
            </div>

            <div class="col-sm-12 col-lg-3">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-gender-ambiguous fs-6 text-info"></i> GENERO:</label>
              <select class="form-select tamaños" @change="Generosi($event)">
                <option selected disabled>{{ desGenero || "-- SELECCIONAR GÉNERO --" }}</option>
                <option v-for="generoItems in Genero" :key="generoItems.id" :value="generoItems.parCorrelativo">
                  {{ generoItems.parDescripcion }}
                </option>
              </select>
            </div>


            <div class="form-group col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-calendar fs-6 text-warning"></i> FECH. NACIMIENTO:</label>
              <input type="date" class="form-control tamaños" v-model="form.posFecNacimiento" />
            </div>

            <!-- FILA 3: PAIS | NACIONALIDAD | DEPARTAMENTO | PROVINCIA | DISTRITO -->
            <div class="col-lg-3 col-sm-12 position-relative">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-flag fs-6 text-primary"></i> PAIS:</label>
              <input type="text" class="form-control tamaños" 
                placeholder="Escribir para buscar país..." 
                v-model="filtroPais" 
                @input="filtroPais = filtroPais.replace(/^\s+/, '')"
                @focus="mostrarListaPais = true" 
                @blur="ocultarListaPais" />
              <ul v-if="mostrarListaPais && paisesFiltrados.length"
                class="list-group position-absolute w-100 mt-1 shadow-sm"
                style="z-index: 2000; max-height: 180px; overflow-y: auto;">
                <li v-for="pais in paisesFiltrados" :key="pais.id"
                  class="list-group-item list-group-item-action tamaños"
                  @mousedown.prevent="seleccionarPais(pais)">
                  {{ pais.parDescripcion }}
                </li>
              </ul>
            </div>

            <div class="col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-flag-fill fs-6 text-info"></i> NACIONALIDAD:</label>
              <select class="form-select tamaños" @change="Nacion($event)">
                <option selected disabled>{{ desNacionalidad }}</option>
                <option v-for="nacionEstados in NacionEstado" :key="nacionEstados.id" :value="nacionEstados.parCorrelativo">
                  {{ nacionEstados.parDescripcion }}
                </option>
              </select>
            </div>

            <div class="col-lg-2 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-building fs-6 text-warning"></i> DEPARTAMENTO:</label>
              <select class="form-select tamaños" @change="DepartamentoEvent($event)">
                <option selected disabled>{{ desDepartamento }}</option>
                <option v-for="departamentoDistritos in DepartamentoDistrito" :key="departamentoDistritos.id" :value="departamentoDistritos.idParametro">
                  {{ departamentoDistritos.parDescripcion }}
                </option>
              </select>
            </div>

            <div class="col-lg-2 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-building fs-6 text-success"></i> PROVINCIA:</label>
              <select class="form-select tamaños" @change="ProvinciaEvent($event)">
                <option selected disabled>{{ desProvincia }}</option>
                <option v-for="provinciaDepas in provinciaDepa" :key="provinciaDepas.id" :value="provinciaDepas.idParametro">
                  {{ provinciaDepas.parDescripcion }}
                </option>
              </select>
            </div>

            <div class="col-lg-2 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-geo-alt fs-6 text-primary"></i> DISTRITO:</label>
              <select class="form-select tamaños" @change="DistritoEvent($event)">
                <option selected disabled>{{ desDistrito }}</option>
                <option v-for="distritoProvins in distritoProvin" :key="distritoProvins.id" :value="distritoProvins.parCorrelativo">
                  {{ distritoProvins.parDescripcion }}
                </option>
              </select>
            </div>

             <!-- FILA 4: CANT. HIJ. | HIJO. MEN | ESTADO DEL POSTULANTE | TELEFONO | TELEFONO ADICIONAL -->
            <div class="form-group col-lg-1 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-people fs-6 text-secondary"></i> HIJ.:</label>
              <input type="number" class="form-control tamaños" min="0" oninput="if(this.value < 0) this.value = 0;" v-model="form.posCanHijos" />
            </div>

            <div class="form-group col-lg-2 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-people fs-6 text-secondary"></i> HIJ. MEN:</label>
              <input type="number" class="form-control tamaños" min="0" oninput="if(this.value < 0) this.value = 0;" v-model="form.posHijosMen" />
            </div>


            <div class="col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-people fs-6 text-success"></i> ESTADO CIVIL:</label>
              <select class="form-select tamaños" @change="EstadoCivil($event)">
                <option selected disabled>{{ desEstCivil || "-- SELECCIONAR ESTADO CIVIL --" }}</option>
                <option v-for="estadoCivil in EstadoCiviles" :key="estadoCivil.id" :value="estadoCivil.parCorrelativo">
                  {{ estadoCivil.parDescripcion }}
                </option>
              </select>
            </div>

            <!-- <div class="form-group col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-briefcase fs-6 text-warning"></i> PERFIL PROFESIONAL:</label>
              <input type="text" class="form-control tamaños" v-model="form.posPerProfesional" @input="form.posPerProfesional = form.posPerProfesional.replace(/^\s+/, '')" />
            </div> -->

            <!-- FILA 6: OCUPACION | GRADO ACADEMICO | ESTUDIOS SUPERIORES -->
            <!-- <div class="form-group col-lg-6 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-briefcase-fill fs-6 text-success"></i> OCUPACION:</label>
              <input type="text" class="form-control tamaños" v-model="form.posOcupacion" @input="form.posOcupacion = form.posOcupacion.replace(/^\s+/, '')" />
            </div> -->

            <div class="col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-mortarboard fs-6 text-dark"></i> GRADO ACADEMICO:</label>
              <select class="form-select tamaños" @change="GradoAcademico($event)">
                <option selected disabled>{{ desGradoAcademico || "-- SELECCIONAR GRADO ACADEMICO --" }}</option>
                <option v-for="gradoAcademicos in gradoAcademico" :key="gradoAcademicos.id" :value="gradoAcademicos.parCorrelativo">
                  {{ gradoAcademicos.parDescripcion }}
                </option>
              </select>
            </div>
<!-- 
              <div class="form-group col-lg-4 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-journal-bookmark fs-6 text-dark"></i> ESTUDIOS SUPERIORES:</label>
              <input type="text" class="form-control tamaños" v-model="form.posEstudios" @input="form.posEstudios = form.posEstudios.replace(/^\s+/, '')" />
            </div> -->

          <div class="form-group col-lg-5 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-geo-alt fs-6 text-danger"></i> DIRECCION:</label>
              <input type="text" class="form-control tamaños" v-model="form.posDireccion" @input="form.posDireccion = form.posDireccion.replace(/^\s+/, '')" />
            </div>
           
           <div class="form-group col-lg-2 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-telephone fs-6 text-success"></i> TELEFONO:</label>
              <input type="text" class="form-control tamaños" v-model="form.posTelefono" @input="form.posTelefono = form.posTelefono.replace(/^\s+/, '')" />
            </div>

            <div class="form-group col-lg-2 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-telephone fs-6 text-primary"></i> TELEFONO ADICIONAL:</label>
              <input type="text" class="form-control tamaños" v-model="form.posTelAdicional" @input="form.posTelAdicional = form.posTelAdicional?.replace(/^\s+/, '')" />
            </div>

            <!-- FILA 5: CORREO | DIRECCION | PERFIL PROFESIONAL -->
            <div class="form-group col-lg-4 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-envelope fs-6 text-info"></i> CORREO:</label>
              <input type="email" class="form-control tamaños" v-model="form.posCorreo" @input="form.posCorreo = form.posCorreo.replace(/^\s+/, '')" />
            </div>

          <!-- Liberar -->
            <div class="col-lg-3 col-sm-12">
              <div class="my-3 ms-2 d-flex align-items-center">
                <input type="checkbox" class="form-check-input me-2" v-model="form.posEstadoConvoca" />
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-unlock fs-5 text-success"></i> LIBERAR USUARIO
                </label>
              </div>
            </div>
            

<!--            

            <div class="form-group col-lg-4 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-person-check fs-6 text-warning"></i> ESTADO DEL POSTULANTE:</label>
              <input type="text" class="form-control tamaños" :disabled="isdisabled" v-model="posEstadoConvoca" />
            </div> -->

            
            <div class="col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-toggle-on fs-6 text-primary"></i> ESTADO:</label>
              <select class="form-select tamaños" @change="Estado($event)">
                <option selected disabled>{{ desEstado }}</option>
                <option v-for="EstadoStatuse in EstadoStatus" :key="EstadoStatuse.id" :value="EstadoStatuse.parCorrelativo">
                  {{ EstadoStatuse.parDescripcion }}
                </option>
              </select>
            </div>
            
             <div class="col col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-exclamation-triangle fs-6 text-danger"></i> MOTIVO DE BLOQUEO:</label>
              <select class="form-select tamaños" :disabled="form.posEstado !== '004'" @change="MotivoEstado($event)">
                <option selected disabled>{{ desMotBloqueo }}</option>
                <option v-for="estadoMotivos in estadoMotivo" :key="estadoMotivos.id" :value="estadoMotivos.parCorrelativo">
                  {{ estadoMotivos.parDescripcion }}
                </option>
              </select>
            </div>

              <div class="col col-lg-2 col-sm-12">
              <label class="tamaño">¿TIENES RENTA QUINTA?</label>
              <div class="form-group d-flex align-items-end mt-2">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" v-model="form.posRentaQuinta" />
                </div>
              </div>
            </div>

             

            <!-- <div class="form-group col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-person-plus fs-6 text-info"></i> USUARIO CREADO:</label>
              <input type="text" class="form-control tamaños" :disabled="isdisabled" v-model="posUsuCreado" />
            </div> -->


           

          </div>

         
        </div>

     <div class="row gy-2 mt-2">
             <!-- FILA 8: MOTIVO DE BLOQUEO | ¿TIENES RENTA QUINTA? -->
           
        <!-- MENSAJE -->
            <div class="col-lg-12 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-chat-left-text fs-6 text-info"></i> MENSAJE:</label>
              <textarea rows="5" class="form-control" :disabled="form.posEstado !== '004'" v-model="form.posComBloqueo" placeholder="Mensaje que dejes como recomendación"></textarea>
            </div>
                      
          

            <!-- FILA 7: ADJUNTO | USUARIO CREADO | ESTADO -->
            <div class="form-group col-lg-6 col-sm-12 ">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi bi-file-earmark fs-6 text-primary"></i> ADJUNTO:</label>
              <input id="fileInput" type="file" class="form-control tamaños" @change="onFileSelected" />
            </div>        
          </div>


            <!-- bancos -->

          <div class="mt-5 row gx-2 gy-2">
            <div class="col col-lg-3 col-sm-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-cash fs-6 text-info me-2"></i> BANCO
                HABERES:</label
              >
              <div>
                <select
                  class="form-select tamaños"
                  aria-label="Default select example"
                  @change="form.posHaberesTipo = $event.target.value"
                >
                  <option disabled selected>
                    {{ desHaberesTipo || "-- SELECCIONAR BANCO HABERES --" }}
                  </option>
                  <option
                    v-for="banco in bancoHaber"
                    :key="banco.id"
                    :value="banco.parCorrelativo"
                  >
                    {{ banco.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col col-lg-3 col-sm-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-coin fs-6 text-success me-2"></i> MONEDA
                (HAB.):</label
              >
              <div>
                <select
                  class="form-select tamaños"
                  aria-label="Default select example"
                  @change="form.posTipoMoneda = $event.target.value"
                >
                  <option disabled selected>
                    {{ desTipoMoneda || "-- SELECCIONAR MONEDA --" }}
                  </option>
                  <option
                    v-for="mone in moneda"
                    :key="mone.id"
                    :value="mone.parCorrelativo"
                  >
                    {{ mone.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col col-lg-3 col-sm-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-cash-stack fs-6 text-danger me-2"></i> BANCO DE
                CTS:</label
              >
              <div>
                <select
                  class="form-select tamaños"
                  aria-label="Default select example"
                  @change="form.posCtsTipo = $event.target.value"
                >
                  <option disabled selected>
                    {{ desCtsTipo || "-- SELECCIONAR BANCO CTS --" }}
                  </option>
                  <option
                    v-for="banco in banCts"
                    :key="banco.id"
                    :value="banco.parCorrelativo"
                  >
                    {{ banco.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-lg-2 col-md-6">
              <label class="tamaño">Moneda(CTS):</label>

              <div>
                <select
                  class="form-select tamaños"
                  aria-label="Default select example"
                  @change="form.posTipoMonedaCts = $event.target.value"
                >
                  <option disabled selected>
                    {{ desTipoMonedaCts || "-- SELECCIONAR MONEDA CTS --" }}
                  </option>
                  <option
                    v-for="mone in moneda"
                    :key="mone.id"
                    :value="mone.parCorrelativo"
                  >
                    {{ mone.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col col-lg-3 col-sm-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-coin text-warning fs-6 me-2"></i>
                Sistema Pensiones:</label
              >
              <div>
                <select
                  class="form-select tamaños"
                  aria-label="Default select example"
                  @change="form.posSistemaPensiones = $event.target.value"
                >
                  <option disabled selected>
                    {{ desSistemaPensiones == 0 || "-- SELECCIONAR SISTEMA PENSIONES --" }}
                  </option>
                  <option
                    v-for="pensiones in sistemPension"
                    :key="pensiones.id"
                    :value="pensiones.parCorrelativo"
                  >
                    {{ pensiones.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col col-lg-3 col-sm-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-telephone fs-6 text-info me-2"></i>
                CONTAC. DE EMERG. (NOMBRES):</label
              >
              <input
                type="text"
                class="form-control tamaños"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                v-model="form.posEmeContacto"
              />
            </div>

            <div class="col col-lg-3 col-sm-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-phone fs-6 text-primary me-2"></i> N° DE
                CELULAR:</label
              >
              <input
                type="text"
                class="form-control tamaños"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                v-model="form.posEmeTelefono"
              />
            </div>
          </div>




      </div>

      <!-- BOTÓN -->
      <div class="d-flex justify-content-center mt-3">
        <button class="btn btn-success mx-2 mb-3 px-5 py-2" @click="guardar">
          <i class="bi bi-pen fs-4 me-2"></i> EDITAR
        </button>
      </div>

    </div>
  </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "SolimanologEditarListado",

  props: {
    numeroDocument: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      file1: null,
      doc: [],
      // seleccionado: "",
      url: "https://apitopas.gruposolimano.com.pe/Documentos/CV/",
      alerta: false,
      posCorreoEnviado: "",
      isdisabled: true,
      desTipDocumento: "",
      desGenero: "",
      desEstCivil: "",
      desPais: "",
      desNacionalidad: "",
      desEstado: "",
      desDepartamento: "",
      desGradoAcademico: "",
      desProvincia: "",
      desDistrito: "",
      desMotBloqueo: "",

        form: {
          idUsuario: "",
          idPostulante: "",
          posTipDocumento: "",
          posNroDocumento: "",
          posUbigeo: "",
          posNombre: "",
          posApePaterno: "",
          posApeMaterno: "",
          posFecNacimiento: "",
          posGenero: "",
          posEstCivil: "",
          posTelefono: "",
          posTelAdicional: "",
          // CodProvincia:"",
          posMotBloqueo: "",
          posPais: "",
          posNacionalidad: "",
          posPerProfesional: "",
          posAdjunto: "",
          posEstado: "",
          posOcupacion: "",
          posCorreo: "",
          posCanHijos: "",
          posDireccion: "",
          posHijosMen: "",
          posGradoAcademico: "",
          posEstudios: "",
          modPostulante: false,
          posEstadoConvoca: "",
          posComBloqueo: "",
          posRentaQuinta:false,
          parametroProvincia :"",
          posPolo: "",
          posPantalon: "",
          posCalzado: "",
          PosImagen: null,
          posHaberesTipo:"",
          posTipoMoneda:"",
          posCtsTipo:"",
          posTipoMonedaCts:"",
          posSistemaPensiones:"",
          posEmeContacto:"",
          posEmeTelefono:"",
          // posDatos:""
        },
      nombreRecuperado: "",
      adjuntoNombre: "",
      previewUrl: null,
      loadingImagen: false,
      filtroPais: "",
      mostrarListaPais: false,
      posUsuCreado: "",
      posEstadoConvoca: "",

      desTipoMoneda:"",
      desTipoMonedaCts:"",
      desCtsTipo:"",
      desSistemaPensiones:"", 
      desHaberesTipo:"",
      desPolo:"",
      desPantalon:"",
      desCalzado:"",

      

      provinciaDepa: [],
      distritoProvin: [],

      gradoAcademico: [],
      estadoMotivo: [],
      polos: [],
      pantalon: [],
      zapatos: [],
      apagate: true,
      posDescripcion: "",
      sistemPension:[],
      bancoHaber:[],
      moneda:[],
      banCts:[],  
    };
  },

  mounted() {
    console.log(this.numeroDocument);

    this.form.idUsuario = localStorage.getItem("userId");

    // this.form.idPostulante = this.$route.params.dni;
    this.form.idPostulante = this.numeroDocument;
    console.log(this.form.idPostulante);


     this.axios.get("ParametroData/Parametro/2535").then((r) => {
      this.sistemPension = r.data;
    });

    this.axios.get("ParametroData/Parametro/7320").then((r) => {
      this.bancoHaber = r.data;
    });

    this.axios.get("ParametroData/Parametro/7317").then((r) => {
      this.moneda = r.data;
    });

    this.axios.get("ParametroData/Parametro/7361").then((r) => {
      this.banCts = r.data;
    });

    this.axios.get("ParametroData/Parametro/2475").then((r) => {
      console.log(r.data);
      this.gradoAcademico = r.data;
    });

    this.axios.get("ParametroData/Parametro/7662").then((r) => {
      console.log(r.data);
      this.estadoMotivo = r.data;
    });

    this.axios.get("ParametroData/Parametro/8006").then((r) => {
      this.polos = r.data;
    });

    this.axios.get("ParametroData/Parametro/8013").then((r) => {
      this.pantalon = r.data;
    });

    this.axios.get("ParametroData/Parametro/8024").then((r) => {
      this.zapatos = r.data;
    });

    this.axios
      .get("Postulante/ObtenerPostulante/" + this.form.idPostulante)
      .then((datos) => {
        console.log("los datos del postulante",datos.data);
        this.doc = datos.data;
        this.posDescripcion = datos.data.posDescripcion;
        this.desTipDocumento = datos.data.desTipDocumento;
        this.desGenero = datos.data.desGenero;
        this.desEstCivil = datos.data.desEstCivil;
        this.desPais = datos.data.desPais;
        this.desNacionalidad = datos.data.desNacionalidad;
        this.desEstado = datos.data.desEstado;
        this.desDepartamento = datos.data.desDepartamento;
        this.desProvincia = datos.data.desProvincia;
        this.desDistrito = datos.data.desDistrito;
        this.form.posUbigeo = datos.data.posUbigeo;
        this.desGradoAcademico = datos.data.desGradoAcademico;
        this.form.posMotBloqueo = datos.data.posMotBloqueo;
        this.desMotBloqueo = datos.data.desMotBloqueo;
        // this.form.CodProvincia = datos.data.CodProvincia
        // this.seleccionado = this.form.DesTipDocumento;
        // console.log(this.form.DesTipDocumento);
        this.form.posTipDocumento = datos.data.posTipDocumento;
        this.form.posNroDocumento = datos.data.posNroDocumento;
        this.form.posNombre = datos.data.posNombre;
        this.form.posApePaterno = datos.data.posApePaterno;
        this.form.posApeMaterno = datos.data.posApeMaterno;
        this.form.posFecNacimiento = datos.data.posFecNacimiento.slice(0, 10);
        this.form.posGenero = datos.data.posGenero;
        this.form.posEstCivil = datos.data.posEstCivil;
        this.form.posTelefono = datos.data.posTelefono;
        this.form.posTelAdicional = datos.data.posTelAdicional;
        this.form.posPais = datos.data.posPais;
        this.form.posNacionalidad = datos.data.posNacionalidad;
        this.form.posPerProfesional = datos.data.posPerProfesional;
        this.form.posAdjunto = datos.data.posAdjunto;
        this.form.posEstado = datos.data.posEstado;
        this.form.posOcupacion = datos.data.posOcupacion;
        this.form.posCorreo = datos.data.posCorreo;
        this.posCorreoEnviado = datos.data.posCorreoEnviado;
        
        this.form.posEstadoConvoca = datos.data.posEstadoConvoca;
        this.posEstadoConvoca = datos.data.posEstadoConvoca; // Para el v-model del template

        this.form.posCanHijos = datos.data.posCanHijos;
        this.form.posDireccion = datos.data.posDireccion;
        this.form.posHijosMen = datos.data.posHijosMen;
        this.form.posGradoAcademico = datos.data.posGradoAcademico;
        this.form.posEstudios = datos.data.posEstudios;
        this.form.posComBloqueo = datos.data.posComBloqueo;
        this.form.posRentaQuinta = datos.data.posRentaQuinta;
        this.form.posPolo = datos.data.posPolo;
        this.form.posPantalon = datos.data.posPantalon;
        this.form.posCalzado = datos.data.posCalzado;
        this.form.posHaberesTipo = datos.data.posHaberesTipo;
        this.form.posTipoMoneda = datos.data.posTipoMoneda;
        this.form.posCtsTipo = datos.data.posCtsTipo;
        this.form.posTipoMonedaCts = datos.data.posTipoMonedaCts;
        this.form.posSistemaPensiones = datos.data.posSistemaPensiones;
        this.form.posEmeContacto = datos.data.posEmeContacto;
        this.form.posEmeTelefono = datos.data.posEmeTelefono;

        this.desHaberesTipo = datos.data.desHaberesTipo;
        this.desTipoMoneda = datos.data.desTipoMoneda;
        this.desCtsTipo = datos.data.desCtsTipo;
        this.desTipoMonedaCts = datos.data.desTipoMonedaCts;
        this.desSistemaPensiones = datos.data.desSistemaPensiones;
        this.desPolo = datos.data.desPolo;
        this.desPantalon = datos.data.desPantalon;
        this.desCalzado = datos.data.desCalzado;

        this.posUsuCreado = datos.data.posUsuCreado;
        this.filtroPais = datos.data.desPais;

        // Cargar previsualización de imagen si existe
        if (datos.data.posImagen) {
          this.previewUrl = datos.data.posImagen;
        }
        // this.form.posDatos =datos.data.posDatos

        this.nombreRecuperado = datos.data.posAdjunto;
        this.form.parametroProvincia = datos.data.parametroProvincia;
        this.ProvinciaEvent();
      });
  },
  computed: {
    ...mapGetters("parametros", [
      "Arreglar",
      "Genero",
      "EstadoCiviles",
      "PaisEstado",
      "EstadoStatus",
      "DepartamentoDistrito",
      "NacionEstado",
    ]),
    ...mapGetters("listadoPostulante", ["Postulante"]),

    paisesFiltrados() {
      if (!this.filtroPais) return this.PaisEstado;
      const busqueda = this.filtroPais.toLowerCase();
      return this.PaisEstado.filter(p => p.parDescripcion.toLowerCase().includes(busqueda));
    }
  },

  created() {},
  methods: {
    ...mapActions("listadoPostulante", ["editar"]),

    // editare(){
    //   this.editar(this.form)
    // },

    guardar() {
      const fd = new FormData();

      fd.append("IdPostulante", this.form.idPostulante);
      fd.append("PosTipDocumento", this.form.posTipDocumento);
      fd.append("PosNroDocumento", this.form.posNroDocumento);
      fd.append("PosNombre", this.form.posNombre);
      fd.append("PosApePaterno", this.form.posApePaterno);
      fd.append("PosApeMaterno", this.form.posApeMaterno);
      fd.append("PosFecNacimiento", this.form.posFecNacimiento);
      fd.append("PosGenero", this.form.posGenero);
      fd.append("PosEstCivil", this.form.posEstCivil);
      fd.append("PosTelefono", this.form.posTelefono);
      fd.append("PosTelAdicional", this.form.posTelAdicional);
      fd.append("PosPais", this.form.posPais);
      fd.append("PosUbigeo", this.form.posUbigeo);
      fd.append("PosNacionalidad", this.form.posNacionalidad);
      fd.append("PosPerProfesional", this.form.posPerProfesional);
      fd.append("idUsuario", this.form.idUsuario);
      fd.append("posMotBloqueo", this.form.posMotBloqueo);

      fd.append("PosEstado", this.form.posEstado);
      fd.append("PosOcupacion", this.form.posOcupacion);
      fd.append("PosCorreo", this.form.posCorreo);
      fd.append("PosCanHijos", this.form.posCanHijos);
      fd.append("PosDireccion", this.form.posDireccion);
      fd.append("PosHijosMen", this.form.posHijosMen);
      fd.append("PosGradoAcademico", this.form.posGradoAcademico);
      fd.append("PosEstudios", this.form.posEstudios);
      fd.append("PosAdjunto", this.form.posAdjunto);
      fd.append("ArchivoPos", this.form.posAdjunto);
      fd.append("modPostulante", this.form.modPostulante);
      fd.append("posEstadoConvoca", this.form.posEstadoConvoca);
      fd.append("posComBloqueo", this.form.posComBloqueo);
      fd.append("posRentaQuinta", this.form.posRentaQuinta);
      fd.append("PosPolo", this.form.posPolo);
      fd.append("PosPantalon", this.form.posPantalon);
      fd.append("PosCalzado", this.form.posCalzado);
      
      fd.append("posHaberesTipo", this.form.posHaberesTipo);
      fd.append("posTipoMoneda", this.form.posTipoMoneda);
      fd.append("posCtsTipo", this.form.posCtsTipo);
      fd.append("posTipoMonedaCts", this.form.posTipoMonedaCts);
      fd.append("posSistemaPensiones", this.form.posSistemaPensiones);
      fd.append("posEmeContacto", this.form.posEmeContacto);
      fd.append("posEmeTelefono", this.form.posEmeTelefono);
     
      
      // Agregar imagen si existe
      if (this.form.PosImagen) {
        fd.append("PosImagen", this.form.PosImagen);
      }

      console.log(this.form);
      this.editar(fd);
    },
    onFileSelected(event) {
      // console.log(event.target.value)
      this.form.posAdjunto = event.target.files[0];

      if (event.target.value != "") {
        this.adjuntoNombre = event.target.files[0].name;
        this.apagate = false;
      } else {
        this.apagate = false;
        this.adjuntoNombre = this.nombreRecuperado;
        this.form.posAdjunto = this.nombreRecuperado;
      }
    },

    seleccionarPais(pais) {
      this.filtroPais = pais.parDescripcion;
      this.form.posPais = pais.parCorrelativo;
      this.mostrarListaPais = false;
      console.log("País seleccionado:", this.form.posPais);
    },

    ocultarListaPais() {
      setTimeout(() => (this.mostrarListaPais = false), 200);
    },

    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.form.PosImagen = file;
        
        // Crear previsualización local
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.previewUrl = null;
      }
    },

    GradoAcademico(event) {
      this.form.posGradoAcademico = event.target.value;
    },

    dosomething(event) {
      this.form.posTipDocumento = event.target.value;

      console.log(event.target.value);
    },
    Generosi(event) {
      this.form.posGenero = event.target.value;
      console.log(this.Postulante);
      console.log(event.target.value);
    },
    EstadoCivil(event) {
      this.form.posEstCivil = event.target.value;
      console.log(event.target.value);
    },
    Pais(event) {
      this.form.posPais = event.target.value;
      console.log(event.target.value);
    },
    Nacion(event) {
      this.form.posNacionalidad = event.target.value;
      console.log(event.target.value);
    },

    Estado(event) {
      this.form.posEstado = event.target.value;
      this.form.posEstado !== "002"
        ? this.form.posMotBloqueo == "" &&
          this.form.posEstado == event.target.value
        : this.form.posEstado == event.target.value;
      console.log(this.form.posEstado);
    },

    MotivoEstado(event) {
      this.form.posMotBloqueo = event.target.value;
      console.log(event);
    },
    DepartamentoEvent(event) {
      let departamento = event.target.value;

      this.getAttributeDepartParms(departamento),
        console.log(event.target.value);
    },

    getAttributeDepartParms(id) {
      this.axios.get(`ParametroData/Parametro/${id}`).then((datos) => {
        this.provinciaDepa = datos.data;
      });
    },

    ProvinciaEvent(event) {
      // Usamos el valor guardado por defecto
      let province = this.form.parametroProvincia;

      // Si viene de un evento (cambio en el select), actualizamos el valor y el estado
      if (event && event.target && event.target.value) {
        province = event.target.value;
        this.form.parametroProvincia = province;
      }

      if (!province) return;

      this.axios.get(`DistritoData/Listar/${province}`).then((datos) => {
        this.distritoProvin = datos.data;
      });
    },

    DistritoEvent(event) {
      this.form.posUbigeo = event.target.value;
      console.log(this.form.posUbigeo);
    },
  },
};
</script>

<style scoped>
.tamaño {
  font-size: 0.65rem;
  font-weight: 700;
  color: #002c5d;
  margin-bottom: 3px;
}

.tamaños {
  font-size: 0.65rem;
  border-radius: 6px;
}

.reducirTamaño {
  font-size: 0.6rem;
  line-height: 1.2;
}

.image-upload-circle {
  width: 160px;
  height: 160px;
  border: 3px solid #e9ecef;
  border-radius: 50%;
  overflow: hidden;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.3s ease;
}

.image-upload-circle:hover {
  border-color: #0d6efd;
}

.img-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay-camera {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 35px;
  background: rgba(0, 44, 93, 0.6);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-upload-circle:hover .overlay-camera {
  opacity: 1;
}

.form-select:disabled, .form-control:disabled {
  background-color: #f1f3f5;
  color: #6c757d;
}
</style>
